import set from 'lodash/set';

export default function setByPath(
  obj: NonNullable<unknown>,
  path: PropertyKey | readonly PropertyKey[],
  value: unknown,
): void {
  set(obj, path, value);
}
